export const TRAINING_DOMAIN_EVALUATION_LIMIT = 11;
export const CFQ_DOMAIN_EVALUATION_LIMIT = 6;
